import Constant from "./../constant/Constant";
import axios from "axios";
import AsyncStorage from "@react-native-community/async-storage";

const header = { "Content-Type": "application/json" };

export class HttpService {
  getHeader() {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + AsyncStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
  }

  getHeader(token) {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
  }

  getHeaderMultipart() {
    return { Authorization: "Bearer " + AsyncStorage.getItem("token") };
  }

  getApi(url) {
    return axios({
      method: "get",
      url: Constant.BASE_URL + url,
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  }

  getApi2(url, token) {
    return axios({
      method: "get",
      url: Constant.BASE_URL + url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
  }

  postApi(url, body) {
    return axios.post(Constant.BASE_URL + url, body, {
      headers: this.getHeader(),
    });
  }

  postApi(url, body) {
    return axios.post(Constant.BASE_URL + url, body, {
      headers: {
        resetPasswordKey:
          "$2a$04$vF9G1hm3tlaTXYq4ugNveuQkf8Fib7qRD3b93wL8zzAKWsxZ.6fY2",
      },
    });
  }

  postApi1(url, body) {
    return axios({
      method: "post",
      url: Constant.BASE_URL + url,
      data: body,
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  }

  signUpApi(url, body) {
    return axios({
      method: "post",
      url: Constant.BASE_URL + url,
      data: body,
      headers: {
        registerkey:
          "$2a$04$b2kAPYKynOUt/Zovx2EDH.Uw1aBmAWtkq.XVx0ndZCVRxRgbrW7jm",
      },
    });
  }

  login(url, body) {
    return axios({
      method: "post",
      url: Constant.BASE_URL + url,
      data: body,
      headers: { "Content-Type": "application/json" },
    });
  }

  sendOtp(url, body) {
    return axios.post(Constant.BASE_URL + url, body, {
      headers: {
        sendotpkey:
          "$2a$04$Tfod0GnOxyEEg25b61i6.OSAMhKGTDyVD1OQuek7FuNjkDMe.0bqK",
      },
    });
  }

  activateUser(url, body) {
    return axios.post(Constant.BASE_URL + url, body, {
      headers: {
        activateKey:
          " $2a$04$.3nAj1Ahd4Bstu1eoc/D9Osbx4CzHJjvggh2HsNS3re2I2syEKPFm",
      },
    });
  }
  authenticate(url, body) {
    return axios.post(Constant.BASE_URL + url, body, { headers: header });
  }

  putApi(url, body) {
    return axios.put(Constant.BASE_URL + url, body, {
      headers: this.getHeader(),
    });
  }

  putApi1(url, body, token) {
    return axios.put(Constant.BASE_URL + url, body, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
    });
  }
  deleteApi(url, params) {
    return axios.delete(Constant.BASE_URL + url, {
      params: params,
      headers: this.getHeader(),
    });
  }
}
